import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { exploreCards } from "../mock";
import useReveal from "../hooks/useReveal";

export default function ExploreCards() {
  const navigate = useNavigate();
  const [ref, inView] = useReveal();

  const handle = (card) => {
    if (card.isRoute) navigate(card.href);
    else document.querySelector(card.href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="kse-section bg-white">
      <div ref={ref} className="kse-container grid md:grid-cols-3 gap-6">
        {exploreCards.map((card, i) => (
          <button
            key={card.title}
            onClick={() => handle(card)}
            className={`group relative h-72 rounded-3xl overflow-hidden text-left reveal ${inView ? "in-view" : ""}`}
            style={{ animationDelay: `${i * 0.12}s` }}
          >
            <img src={card.image} alt={card.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#111c4e]/90 via-[#111c4e]/30 to-transparent" />
            <div className="absolute bottom-0 left-0 p-7 flex items-end justify-between w-full">
              <h3 className="text-white font-bold text-2xl leading-tight">{card.title}</h3>
              <span className="w-11 h-11 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-white group-hover:text-[#1a2a6b] text-white transition-all">
                <ArrowUpRight size={20} />
              </span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
